
import { AuthSocketService, MainSocketService } from "@/services";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			isForceReconnecting: false
		};
	},
	methods: {
		logout(){
			AuthService.logout();
		},
		async forceReconnect(){
			if (this.isForceReconnecting) return;
			this.isForceReconnecting = true;
			try{
				await MainSocketService.disconnect();
				await AuthSocketService.disconnect();
				await AuthSocketService.connect(AuthService.wfDossier.id);
				await MainSocketService.connect(AuthService.wfDossier.id);
			}catch(err){
			}finally{
				this.isForceReconnecting = false;
			}
		}
	},
	i18nEx: {
		componentPrefix: "views.TheMain"
	}
});
